import { createAction } from "@reduxjs/toolkit";
import {
    SET_SELECTED_ROWS,
    GET_ALL_PROPOSED_REGULATIONS,
    ALL_PROPOSED_REGULATIONS_RECEIVED,
    PUBLISH_REGULATIONS,
    DELETE_REGULATIONS,
    EXPORT_REGULATIONS,
    SET_REGULATION_NAME,
    GET_DATA_FOR_FILTERS,
    DATA_FOR_FILTERS_RECEIVED,
    SET_PROPOSED_CHANGES_FILTER_PARAMS,
    TOGGLE_ACTION_PERFORMED,
    GetAllProposedRegulationsAction,
    SetRegulationNameAction,
    AllProposedRegulationsReceivedAction,
    PublishMultipleRegulationsAction,
    DeleteRegulationsAction,
    ExportRegulationsAction,
    GetDataForFiltersAction,
    DataForFiltersReceivedAction,
    SetProposedChangesFilterParamsAction,
    SelectedRowAction,
    SelectedRegulationColumnAction,
    SELECTED_REGULATION_COLUMNS,
    DELETE_PARKING_RATES_BATCH,
    DeleteParkingRatesBatchAction
} from "./types";

export const setSelectedRows = createAction<SelectedRowAction["payload"]>(SET_SELECTED_ROWS);

export const getAllProposedRegulations = createAction<GetAllProposedRegulationsAction["payload"]>(
    GET_ALL_PROPOSED_REGULATIONS
);

export const setRegulationName =
    createAction<SetRegulationNameAction["payload"]>(SET_REGULATION_NAME);

export const allProposedRegulationsReceived = createAction<
    AllProposedRegulationsReceivedAction["payload"]
>(ALL_PROPOSED_REGULATIONS_RECEIVED);

export const publishMultipleRegulations =
    createAction<PublishMultipleRegulationsAction["payload"]>(PUBLISH_REGULATIONS);

export const deleteRegulations =
    createAction<DeleteRegulationsAction["payload"]>(DELETE_REGULATIONS);

export const deleteParkingRatesBatch = createAction<DeleteParkingRatesBatchAction["payload"]>(
    DELETE_PARKING_RATES_BATCH
);

export const exportMultipleRegulations =
    createAction<ExportRegulationsAction["payload"]>(EXPORT_REGULATIONS);

export const getDataForFilters =
    createAction<GetDataForFiltersAction["payload"]>(GET_DATA_FOR_FILTERS);

export const dataForFiltersReceived =
    createAction<DataForFiltersReceivedAction["payload"]>(DATA_FOR_FILTERS_RECEIVED);

export const setProposedChangesFilterParams = createAction<
    SetProposedChangesFilterParamsAction["payload"]
>(SET_PROPOSED_CHANGES_FILTER_PARAMS);

export const toggleActionPerformed = createAction(TOGGLE_ACTION_PERFORMED);

export const setSelectedRegulationColumns = createAction<SelectedRegulationColumnAction["payload"]>(
    SELECTED_REGULATION_COLUMNS
);
